import { useActiveAccountId, useActiveShareId } from '@frameio/shared/contexts';

export function useIsPublicShare() {
  const accountId = useActiveAccountId() ?? '';
  const shareId = useActiveShareId() ?? '';

  return !accountId && !!shareId;
}
